export const environment = {
	production: true,
	posthog: 'phc_lPJnjN5hrM8Dh7kgujIccs2xnGL2lmRv6UdOmOTCqEc',
	enterprise: true
};
